import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getBaladiyaData = createAsyncThunk("api/baladiya?type=1", async (token) => {
    try {
        const response = await nodeinstance.get("/baladiya?type=1", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const BaladiyaDataSlice = createSlice({
    name: "absher",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBaladiyaData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getBaladiyaData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getBaladiyaData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getBaladiyaData };
export default BaladiyaDataSlice.reducer;
